import { IBaseSearchRequest } from "src/app/core/models/base";
import { Employee, IEmployee } from "src/app/employee/employee";
import { IRessourceCategory } from "./ressource-category";

export interface IRessource {
    id: string,
    name: string,
    nameShort: string,
    isHidden: boolean;
    ressourceCategoryId?: string,
    ressourceCategory: IRessourceCategory,
    employee: IEmployee,
    employeeId: string,
    ressourceType: RessourceType
}

export interface ICreateRessourceRequest{
    name: string,
    nameShort: string,
    ressourceCategoryId: string
}

export interface ISearchRessourceRequest extends IBaseSearchRequest{
    employeeId?: string,
    ressourceType?: RessourceType,
    isNotHidden?: boolean
}

export enum RessourceType {
    Ressource = 0,
    Employee = 1
}